import { LtlPipelineViewModel } from "../ViewModel/LtlPipelineViewModel";

export default function fixLtlRoutingIdInLtlPipelines(
  ltlPipelines?: Array<LtlPipelineViewModel>
): Array<LtlPipelineViewModel> {
  return (
    ltlPipelines?.map((ltlPipeline) => {
      return {
        ...ltlPipeline,
        routing: ltlPipeline.routing?.map((routing) => {
          return {
            ...routing,
            LtlRoutingId: (ltlPipeline.routing?.indexOf(routing) || 0) + 1,
          };
        }),
      };
    }) || []
  );
}
